<template>
  <v-app-bar
    style="padding-left: 1%; padding-right: 1%; color: white"
    color="#4BA0B2"
  >
    <v-app-bar-nav-icon v-if="false"></v-app-bar-nav-icon>
    <v-toolbar-title @click="goHomePage()"
      >
      <v-row>
        <v-col><v-img width="180" lazy-src="https://www.kmppartners.info/logo-transparent.png" src="https://www.kmppartners.info/logo-transparent.png"></v-img></v-col></v-row></v-toolbar-title
    >
    <v-spacer></v-spacer>
    <v-btn
      outlined
      text
      class="ml-2 mr-2 headlink"
      v-if="display !== 'Mobile'"
      @click="why()"
    >
      <span style="color: white">ทำไมต้อง KanPramool</span>
    </v-btn>
    <v-btn
      outlined
      text
      class="ml-2 headlink"
      v-if="display !== 'Mobile'"
      @click="viewArchives()"
    >
      <span style="color: white">บทความ</span>
    </v-btn>
    <!-- <v-btn
      outlined
      text
      class="ml-2 mr-2 headlink"
      v-if="display !== 'Mobile' && !$auth.isAuthenticated && !$auth.loading"
      @click.prevent="loginCustomer()"
    >
      <span style="color: white">เข้าสู่ระบบ</span>
    </v-btn> -->
    <!-- <v-menu left bottom v-if="display !== 'Mobile'">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
        v-bind="attrs"
          v-on="on"
          outlined
          text
          class="mr-2 headlink"
        >
          <v-avatar class="mr-2" size="40">
            <img :src="$auth.user.picture" />
          </v-avatar>
          <span style="color: white">{{ $auth.user.name }}</span>
        </v-btn>
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon color="white">mdi-menu</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-if="display !== 'Mobile'">
          <v-list-item-title style="cursor: pointer" @click="viewProfile()"
            >จัดการบัญชี</v-list-item-title
          >
        </v-list-item>
        <v-list-item v-if="display !== 'Mobile'">
          <v-list-item-title style="cursor: pointer" @click="logOut()()"
            >ออกจากระบบ</v-list-item-title
          >
        </v-list-item>
      </v-list>
    </v-menu> -->

    <!-- <v-menu v-if="!isLogin" left bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon color="white">mdi-menu</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item v-if="display === 'Mobile'">
          <v-list-item-title style="cursor: pointer" @click="why()"
            >ทำไมต้อง KanPramool</v-list-item-title
          >
        </v-list-item>
        <v-list-item v-if="display === 'Mobile'">
          <v-list-item-title style="cursor: pointer" @click="viewArchives()"
            >บทความ</v-list-item-title
          >
        </v-list-item>
        
        <v-list-item v-if="display === 'Mobile'">
          <v-list-item-title
            style="cursor: pointer"
            @click.prevent="loginCustomer()"
            v-if="!$auth.isAuthenticated && !$auth.loading"
            >เข้าสู่ระบบ</v-list-item-title
          >
          <v-list-item-title
            style="cursor: pointer"
            @click="viewProfile()"
            v-if="$auth.isAuthenticated"
          >
            <v-avatar class="mr-2" size="30">
              <img :src="$auth.user.picture" />
            </v-avatar>
            {{ $auth.user.name }}</v-list-item-title
          >
        </v-list-item>
        <v-list-item>
          <v-list-item-title
            v-if="!$auth.isAuthenticated"
            style="cursor: pointer"
            @click="loginStaff()"
            >สำหรับพนักงาน</v-list-item-title
          >
          <v-list-item-title v-else style="cursor: pointer" @click="logOut()"
            >ออกจากระบบ</v-list-item-title
          >
        </v-list-item>
      </v-list>
    </v-menu>
    <v-menu v-else left bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="display !== 'Mobile'"
          v-bind="attrs"
          depressed
          color="#4BA0B2"
          style="padding-right: 0px"
          v-on="on"
        >
          <span style="font-size: 20px"
            >{{ fullname }}<v-icon>mdi-user</v-icon></span
          >
          <v-icon class="ml-1">mdi-menu-down</v-icon>
        </v-btn>
        <v-btn
          v-else
          v-bind="attrs"
          depressed
          color="#4BA0B2"
          style="padding-right: 0px"
          v-on="on"
        >
          <v-icon class="ml-1">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-title @click="logOut()">ออกจากระบบ</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu> -->
  </v-app-bar>
</template>

<script>
export default {
  data: () => ({
    isLogin: true,
    display: null,
    fullname: localStorage.getItem("fullname_customer"),
    user:{

    },
  }),
  created() {
    this.checkDisplay();
  },
  mounted() {
    if (localStorage.getItem("fullname_customer") === null) {
      this.isLogin = false;
    } else {
      this.isLogin = true;
    }
  },
  methods: {
    goHomePage(){
      this.$router.push("/")
    },
    logOut() {
      this.$auth.logout();
    },
    viewProfile() {
      this.$router.push("/profile")
    },
    why() {},
    viewArchives() {},
    projecttoday(){
    window.open("https://www.kanpramool.com/projecttoday/", "_blank");
    },
    loginCustomer() {
      this.$auth.loginWithRedirect();
    },
    loginStaff() {
      this.$router.push("/login");
    },
    checkDisplay() {
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        this.display = "Tablet";
      } else if (
        /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        this.display = "Mobile";
      } else {
        this.display = "Desktop";
      }
    },
  },
};
</script>

<style>
.headlink {
  border-color: rgb(0, 0, 0, 0) !important;
}
</style>
